(function () {

    'use strict';
    angular
        .module('app.search')
        .factory('UtilitiesService', [
            '$location',
            '$window',
            UtilitiesService
        ]);

    function UtilitiesService($location, $window) {
        return {
            appCondValTransformers: {
                "nameTransformer": function (conditionValues, mapping) {
                    var cv = conditionValues;
                    return cv.filter(function (x) {
                        return (mapping[x.name] !== undefined);
                    }).map(function (x) {
                        var mapped = mapping[x.name];
                        if (mapped) x.name = mapped;
                        return x;
                    });
                }
            },
            mergeEnums: function (cv) {
                function diff(arr1, arr2, id) {
                    if (!id) id = function (x) {
                        return x
                    };
                    var o = {}, diff = [];
                    arr2.forEach(function (x) {
                        o[id(x)] = true
                    });
                    arr1.forEach(function (x) {
                        if (!o[id(x)]) diff.push(x)
                    });
                    return diff;
                }

                return cv.data.concat(diff(cv.enum, cv.data, function (x) {
                    return x.id
                }));
            }
        }
    }

})();


// WEBPACK FOOTER //
// ./app/search/components/service/UtilitiesService.js